import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'settings-request-query-builder',
  templateUrl: './request-query-builder.component.html',
  styleUrls: ['./request-query-builder.component.scss']
})
export class RequestQueryBuilderComponent implements OnInit {
  statusFilter = '';
  requesterFilter = '';
  reviewerFilter = '';
  settingFilter = '';
  statuses = ['Awaiting Approval', 'Approved', 'Rejected', 'Completed', 'Failed'];

  @Output() search = new EventEmitter();

  ngOnInit(): void { }

  reset() {
    this.statusFilter = '';
    this.requesterFilter = '';
    this.reviewerFilter = '';
    this.settingFilter = '';
  }

  async onSearchClick(): Promise<void> {
    let query = {};

    if (this.statusFilter) {
      query['status'] = this.statusFilter;
    }
    if (this.requesterFilter) {
      query['requester'] = this.requesterFilter;
    }
    if (this.reviewerFilter) {
      query['reviewer'] = this.reviewerFilter;
    }
    if (this.settingFilter) {
      query['setting'] = this.settingFilter;
    }

    this.search.emit(query);
  }
}
